import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response";

export const useDeleteStandings = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { sport, organizationId, seasonId } = useParams();
  const { formatMessage } = useIntl();
  const notification = useNotification();
  return useMutation<DefaultOperationSuccessResponse, Error>({
    mutationFn: async () => {
      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/standings?forceDelete=true`, {
        method: "DELETE",
      });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success) {
        await queryClient.invalidateQueries({
          queryKey: ["standings", sport, organizationId, seasonId],
          exact: false,
        });
        notification.success({
          message: formatMessage({ id: "standings.delete.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
